document.addEventListener('click', (e) => {
    if (e.target.closest('a')) {
        const link = e.target.closest('a')

        let href = link.getAttribute('href')

        if (
            !href.startsWith('#') ||
            (href.startsWith('#') && href.length < 2) ||
            link.classList.contains('open-gallery')
        ) {
            return
        }

        e.preventDefault()
        let target = document.querySelector(href)
        if (!target) {
            return
        }

        let headerOffset = 130
        let elementPosition = target.offsetTop
        let offsetPosition = elementPosition - headerOffset

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        })
    }
})
